<script setup>
import { computed } from 'vue'
import { Globe2 } from 'lucide-vue-next'

import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { cn } from '@/lib/utils'
import { SUPPORTED_PLATFORM_OPTIONS } from './useGlobalCreatorSearch'

const props = defineProps({
    modelValue: { type: String, required: true },
})

const emit = defineEmits(['update:modelValue', 'openChange'])

const selectedPlatform = computed(
    () => SUPPORTED_PLATFORM_OPTIONS.find((platform) => platform.id === props.modelValue) || SUPPORTED_PLATFORM_OPTIONS[0],
)
</script>

<template>
    <Select
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
        @update:open="emit('openChange', $event)"
    >
        <SelectTrigger
            aria-label="Search platform"
            :title="selectedPlatform.label"
            class="h-8 w-12 min-w-0 shrink-0 justify-between rounded-sm border-0 bg-transparent px-2 py-0 shadow-none hover:bg-slate-50 focus:ring-0 focus-visible:ring-0"
        >
            <span class="flex items-center justify-center">
                <Globe2 v-if="selectedPlatform.id === 'all'" class="h-3.5 w-3.5 text-slate-500" />
                <AppIcon
                    v-else
                    :name="selectedPlatform.icon"
                    class="h-3.5 w-3.5"
                    :class="selectedPlatform.iconClass"
                />
            </span>
        </SelectTrigger>

        <SelectContent align="start" class="w-44">
            <SelectItem
                v-for="platform in SUPPORTED_PLATFORM_OPTIONS"
                :key="platform.id"
                :value="platform.id"
                :text-value="platform.label"
                :class="cn('gap-2', platform.id === modelValue && 'font-medium')"
            >
                <span class="flex items-center gap-2">
                    <Globe2 v-if="platform.id === 'all'" class="h-4 w-4 text-slate-500" />
                    <AppIcon
                        v-else
                        :name="platform.icon"
                        class="h-4 w-4"
                        :class="platform.iconClass"
                    />
                    <span>{{ platform.label }}</span>
                </span>
            </SelectItem>
        </SelectContent>
    </Select>
</template>
